module.exports = __webpack_public_path__ + "img/icon_map_61_off_010.d70ee277.png";